{
  "home": {
    "title": "AquaWorks | Suivi étudiant de la qualité de l'eau",
    "description": "AquaWorks est un projet d'ingénierie mené par des étudiants, développé par des étudiants de l'Université de la Colombie-Britannique. Le site est situé sur le campus de Vancouver de l'Université de la Colombie-Britannique."
  },
  "about": {
    "title": "Feuille de route AquaWorks Phase 1",
    "description": "Feuille de route AquaWorks (phases 1–3) : objectifs, sous-systèmes, limites de périmètre et calendrier du projet jusqu'à l'archive de passation de janvier 2027."
  },
  "science": {
    "title": "Indicateurs, eaux pluviales du campus de Vancouver et ODD | AquaWorks",
    "description": "Pourquoi le suivi mobile de la qualité de l'eau compte sur le campus de Vancouver : eaux pluviales, cinq indicateurs clés, et alignement d'AquaWorks sur les ODD."
  },
  "team": {
    "title": "Équipe AquaWorks — logiciel, électricité, mécanique",
    "description": "Rencontrez les responsables AquaWorks et quatre équipes étudiantes — logiciel, électricité, mécanique, affaires — développées par des étudiants de l'Université de la Colombie-Britannique."
  },
  "updates": {
    "title": "Journal de construction AquaWorks Phase 1",
    "description": "Suivez les jalons AquaWorks Phase 1 : mise en place, validation en eau contrôlée, et archive de passation de janvier 2027 pour les prochaines équipes étudiantes."
  },
  "updateDetail": {
    "title": "{{title}} | Actualités AquaWorks",
    "description": "{{summary}}"
  },
  "getInvolved": {
    "title": "Rejoindre AquaWorks — équipe étudiante de suivi de l'eau",
    "description": "Rejoignez une sous-équipe AquaWorks. Les étudiants de l'Université de la Colombie-Britannique peuvent contacter les responsables pour l'accueil, le conseil et les questions de la Phase 1."
  },
  "notFound": {
    "title": "Page introuvable — 404 | AquaWorks",
    "description": "Cette page AquaWorks n'existe pas. Retournez à l'accueil ou ouvrez les pages projet, science et rejoindre."
  }
}
